import React, { useRef, useEffect, useState } from "react";
import { CallCalling, Sound, CallRemove } from "iconsax-reactjs";

import { ReactComponent as LOADINGCHAT } from "../../build/images/loading.svg";
import { ReactComponent as WHATSAPPVOICEICON } from "../../build/images/whatsapp_voice.svg";
import CHAMANDO from "../../build/images/calling.svg";
import LIGACAO from "../../build/images/in_call.svg";
import DISCANDO from "../../build/images/discando.svg";
import AFTERCALLWORK from "../../build/images/aftercallwork.svg";

const StatusAgentStatus = ({ status, idmidia }) => {
  const circleRef = useRef(null);
  const animationIdRef = useRef(null);
  const silenceTimeoutRef = useRef(null);

  const [useRealAudio, setUseRealAudio] = useState(false);

  const startWebRTCVisualizer = () => {
    const mizuApi = window.webphone_api;

    // 1. Verifica API
    if (!mizuApi || typeof mizuApi.getrtcpeerconnection !== "function") {
      animationIdRef.current = requestAnimationFrame(startWebRTCVisualizer);
      return;
    }
    // 2. Tenta pegar a conexão
    const pc = mizuApi.getrtcpeerconnection();
    if (!pc) {
      animationIdRef.current = requestAnimationFrame(startWebRTCVisualizer);
      return;
    }

    // console.log(
    //   "Visualizador: Conexão WebRTC encontrada. Iniciando leitura..."
    // );

    let currentLevel = 0;

    const updateVisuals = async () => {
      if (!circleRef.current || pc.connectionState === "closed") return;

      try {
        const stats = await pc.getStats();
        let maxAudioLevel = 0;

        stats.forEach((report) => {
          if (report.audioLevel && typeof report.audioLevel === "number") {
            if (report.audioLevel > maxAudioLevel) {
              maxAudioLevel = report.audioLevel;
            }
          }
        });

        // console.log("Visualizador Máximo Encontrado:", maxAudioLevel);
        if (maxAudioLevel > 0 && !useRealAudio) {
          setUseRealAudio(true);
          if (silenceTimeoutRef.current)
            clearTimeout(silenceTimeoutRef.current);
        }

        if (maxAudioLevel < 0.01) maxAudioLevel = 0;

        if (maxAudioLevel > currentLevel) {
          currentLevel += (maxAudioLevel - currentLevel) * 0.5;
        } else {
          currentLevel += (maxAudioLevel - currentLevel) * 0.1;
        }

        if (currentLevel < 0.002) {
          circleRef.current.style.boxShadow = "none";
        } else {
          const intensity = Math.min(currentLevel * 1.5, 1.0);

          const s1 = intensity * 12;
          const s2 = intensity * 28;
          const s3 = intensity * 44;

          circleRef.current.style.boxShadow = `
                    0 0 0 ${s1}px rgba(191, 195, 202, 0.50),
                    0 0 0 ${s2}px rgba(191, 195, 202, 0.30),
                    0 0 0 ${s3}px rgba(191, 195, 202, 0.10)
                `;
        }
      } catch (err) {
        console.warn("Erro stats:", err);
      }

      animationIdRef.current = requestAnimationFrame(updateVisuals);
    };

    updateVisuals();
  };

  const stopVisualizer = () => {
    if (animationIdRef.current) cancelAnimationFrame(animationIdRef.current);
    if (silenceTimeoutRef.current) clearTimeout(silenceTimeoutRef.current);
  };

  useEffect(() => {
    stopVisualizer();
    setUseRealAudio(false);

    if (
      status === "Ligação" &&
      (parseInt(idmidia) === 1 || parseInt(idmidia) === 16)
    ) {
      setTimeout(startWebRTCVisualizer, 1000);
    }

    return () => stopVisualizer();
  }, [status, idmidia]);

  const activeCallClass = useRealAudio ? "" : "pulsing-fake";

  if (status === "Livre" || status === "Atendimento") return null;

  let classMidia = `call-content__box__img ${parseInt(idmidia) === 16 ? "vozwhats" : ""}`;
  let classTextMidia = `call-content__box__text ${parseInt(idmidia) === 16 ? "vozwhats-text" : ""}`;

  // status = "Discando";
  return (
    <>
      {status === "Discando" &&
      (parseInt(idmidia) === 1 || parseInt(idmidia) === 16) ? (
        <div className="block-content-call">
          <div className="call-content">
            <div className="call-content__box active ">
              {/* <img src={DISCANDO} width="200" alt="" /> */}
              <div className={`${classMidia} pulsing-fake`}>
                {parseInt(idmidia) === 16 ? (
                  <WHATSAPPVOICEICON width={48} height={48} />
                ) : (
                  <CallCalling size={36} color="#ffffff" />
                )}
              </div>
              <div className="calling">
                <p className={classTextMidia}>Discando...</p>
                <div className="calling__content"></div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {status === "Chamando" &&
      (parseInt(idmidia) === 1 || parseInt(idmidia) === 16) ? (
        <div className="block-content-call">
          <div className="call-content">
            <div className="call-content__box active ">
              {/* <img src={CHAMANDO} width="200" alt="" /> */}
              <div className={`${classMidia} pulsing-fake`}>
                {parseInt(idmidia) === 16 ? (
                  <WHATSAPPVOICEICON width={48} height={48} />
                ) : (
                  <CallCalling size={36} color="#ffffff" />
                )}
              </div>
              <div className="calling">
                <p className={classTextMidia}>Chamando...</p>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {status === "ChamandoChat" ? (
        <div className="block-content-call">
          <div className="call-content">
            <div className="call-content__box active ">
              <LOADINGCHAT />
              <div className="chat-canvas__loading">
                <LOADINGCHAT />
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {status === "Ligação" &&
      (parseInt(idmidia) === 1 || parseInt(idmidia) === 16) ? (
        <div className="block-content-call">
          <div className="call-content">
            <div className="call-content__box active ">
              {/* <img src={LIGACAO} width="200" alt="" /> */}
              <div
                className={`${classMidia} ${activeCallClass}`}
                ref={circleRef}
              >
                <Sound size={36} color="#ffffff" />
              </div>
              <p className={classTextMidia}>Em ligação...</p>
            </div>
          </div>
        </div>
      ) : null}
      {status === "Aftercallwork" &&
      (parseInt(idmidia) === 1 || parseInt(idmidia) === 16) ? (
        <div className="block-content-call">
          <div className="call-content">
            <div className="call-content__box active after-call-work">
              {/* <img src={AFTERCALLWORK} width="200" alt="" /> */}
              <div className={`${classMidia} pulsing-fake`}>
                <CallRemove size={36} color="#ffffff" />
              </div>
              <div className="calling">
                <p className={classTextMidia}>After Call Work...</p>
                <p className="call-content__box__text2">
                  Garanta que foi realizado um bom atendimento e se prepare para
                  a próxima chamada.
                </p>
              </div>
            </div>

            {/* <div className="call-content__box active">
                    <img src={AFTERCALLWORK} height="200" alt="" />
                    <p className="call-content_box_text">After call work...</p>
              </div> */}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default StatusAgentStatus;
